<fz-chip-group>
  @for (item of items() || []; track item.key) {
    <fz-chip
      [image]="item.image"
      [label]="item.label"
      [matTooltip]="'Remove ' + item.label + ' from your selection.'"
      [highlighted]="true"
      [removable]="true"
      (click)="removeSelection(item.group, item.key)"
    />
  }
</fz-chip-group>
